
import { of, forkJoin, Observable, ObjectUnsubscribedError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpClientModule, HttpParams, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../app.config';

import { AsdBase } from '../../model/asd/asd';
import { FormMatrix } from '../../model/form/form-properties/form-matrix';
import { User } from '../../model/user/user';
import { TreeUseractions } from '../../model/useraction/task-useraction/tree-useractions'
import { FlexSearchRequest, Filter } from '../../model/server/flexSearchRequest';

import '../rxjs-operators';
import { TreeRequest } from 'src/app/model/useraction/useractions';

@Injectable()
export class CosyCommunicationControllerService {
  constructor(private http: HttpClient, private config: AppConfig) { }

  private uxMatrices: any;
  private cachedMatrices: FormMatrix[] = [];
  private asdTemplatesUrl = '/asd-templates';

  public bckupASD;
  public customASD;
  public loginUserAction: string;
  public sessionID: string;
  public url = this.config.getConfig('apiURL');
  public curryAPICredentials = this.config.getConfig('curryAPIcredentials');
  public globalSessionID: string;
  public appID: string;
  public localSessionID: string;
  public locale: string;
  public langFromServer;
  public selectAllText;
  public searchOption: SearchOption[] = [];
  public searchResult: SearchOption[] = [];
  public RTKeyAllowDynaEdit: boolean;
  public RTKeyShowNullable: boolean;
  public static currentLocale : string;


  
  getAccessPermission(){
   
    let body = {
      "ACSubjectId": "9BA4223A-23E3-40E0-8A25-8887C4E281DC",
      "ACObjectId": "28191021-C5DB-4E43-95C4-1AF8615D044A",
      "ACOperationId": "D5FDC3B8-0317-4F53-908A-B07D55D39854",
      "MandatorId": "8713245C-4C83-426C-849E-121D7C8594EA",
      "ConsumerId": "0DFE1877-DA69-4987-A3CA-3466AC050A93",
      "VariantId": "",
      "CosyRequired": true
    }
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    this.http
    .post(this.url+'access/Allow', body, httpOptions).pipe(
      map(res => { console.log(res)}))
    .subscribe(
      success => { console.log('Yes theres is something on server')},
      error => {
        console.log('Error in access permission: ', error);
      }
    );
  }
  getCosyCustomDocument(asdFromAPI: AsdBase) {
    let body = { sessionID: asdFromAPI.Header.SessionID, appStateID: asdFromAPI.Header.AppStateID };
    let casd: AsdBase;

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(this.url + 'dux/loadCustomASD', body, httpOptions).pipe(map(res => {
      return res;
    }));
  }

  postUpdatedCosyCustomDocument(sessionID: string, casdFromAPI: AsdBase) {
    let body = { sessionID: sessionID, appStateID: casdFromAPI.Header.AppStateID, CosyDocument: casdFromAPI };
    console.log('CASD Request: ', body)
   
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    this.http
      .post(this.url + 'dux/saveCustomASD', body, httpOptions).pipe(
        map(res => { }))
      .subscribe(
        success => { },
        error => {
          console.log('Error in sending updated CASD: ', error);
        }
      );
  }

  getLanguageList(sessionID){
    let body = { sessionID: sessionID };
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json');
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };

    return this.http.post(this.url + 'dux/getLanguageList', body, httpOptions).pipe(timeout(300000), map(res => {
      return res;
    }));

  }

  postGridEditedData(sessionID, rowID, objectID, columnName, editedValue){

    let body = { sessionID: sessionID, 
                 ID: rowID, 
                 entityID: objectID,
                 attribute: columnName,
                 value: editedValue};
    console.log('GridCell Change Request: ', body);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    this.http
      .post(this.url + 'dux/saveEntity', body, httpOptions).pipe(
        map(res => { }))
      .subscribe(
        success => { },
        error => {
          console.log('Error in sending Grid Edited Data: ', error);
        }
      );
  }

  getOtherCosyDocuments(asdViewTemplateID: string, appStateID: string, appName: string) {
    let docs: any[] = [];

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    let cosyDesignDocument = this.http.get('assets/asd-docs/' + appStateID + '-design.json').pipe(catchError(error => of('Error')));
    let cosyTemplateDocument = this.http.get('assets/asd-docs/' + asdViewTemplateID + '-template.json')
    let cosyCustomTemplateDocument = this.http.get('assets/asd-docs/' + appStateID + '-template.json').pipe(catchError(error => this.http.get('assets/asd-docs/' + asdViewTemplateID + '-' + appName + '-template.json').pipe(catchError(error => of('Error')))));
    let cosyMessagesDocument = this.http.get('assets/asd-docs/MessagesDE.json')
   
    docs.push(cosyTemplateDocument);
    docs.push(cosyDesignDocument);
    docs.push(cosyMessagesDocument);
    docs.push(cosyCustomTemplateDocument);
    return forkJoin(docs);
  }

  executeUserAction(asd: AsdBase, sessionID, userActionID, interfaceElementID) {
    if (sessionID == null) {
      sessionID = this.globalSessionID;
    }
    let toPostAsd = { CosyDocument: asd };
    let body = { userActionID: userActionID, sessionID: sessionID, cosyAppStateDocument: toPostAsd, interfaceElementID: interfaceElementID };
    console.log('Body:', JSON.stringify(body));
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json');
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };

    return this.http.post(this.url + 'dux/executeUserAction', body, httpOptions).pipe(timeout(900000), map(res => {
      this.bckupASD = res;
      console.log(res);
      return res;
    }));
  }

  postServerStateChangeOnServer(sessionID: string, interfaceElementID: string, stateID: string) {
    let body = { sessionID: sessionID, interfaceelementID: interfaceElementID, value: stateID };
    console.log('Server State Body: ', JSON.stringify(body));
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    this.http
      .post(this.url + 'forms/setActiveState', body, httpOptions).pipe(
        map(res => { }))
      .subscribe(
        success => { },
        error => {
          console.log('Error in sending State Change Request: ', error);
        }
      );
  }

  postDownLoadFile(sessionID: string, fileName: string) {
    let body = { sessionID: sessionID, fileName: fileName };
    console.log('DownLoadFile Body: ', JSON.stringify(body));
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(this.url + 'files/downloadB64File', body, httpOptions).pipe(map(res => {
      return res;
    }));
  }

  getFormControlMatrices(sessionID, uxControllerMatrixID: string) {
    let cachedMatrix: FormMatrix;
    let formMatrix: FormMatrix = new FormMatrix(null, null);
    let body = { sessionID: sessionID, formControllerMatrixID: uxControllerMatrixID };

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    cachedMatrix = this.chkMatricesInCache(this.cachedMatrices, uxControllerMatrixID);

    if (uxControllerMatrixID == null) {
      formMatrix.UXControllerMatrices = [];
      return of(formMatrix.UXControllerMatrices);
    } else {
      if (cachedMatrix != null) {
        return of(cachedMatrix.UXControllerMatrices);
      } else {
        return this.http.post(this.url + 'forms/getMatrices', body, httpOptions).pipe(map(res => {
          this.uxMatrices = res;
          this.cachedMatrices.push(new FormMatrix(uxControllerMatrixID, this.uxMatrices));
          console.log('Matrix: ', this.uxMatrices);
          return this.uxMatrices;
        }));
      }
    }
  }

  chkMatricesInCache(cachedMatrices: FormMatrix[], uxControllerMatrixID) {
    let formMatrix: FormMatrix;
    for (let cm of cachedMatrices) {
      if (cm.UXControllerMatrixID == uxControllerMatrixID) {
        formMatrix = cm;
      }
    }
    return formMatrix;
  }

  authorizeUser(userActionID, user: User) {
    this.loginUserAction = userActionID;

    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header, withCredential: true
    };
    let body = { login: user.login, password: user.password, authToken: user.authToken, mandatorID: user.mandatorID, appID: user.appID, managedAppID: user.managedAppID, autoAuthorize: user.autoAuthorize, cosyToken: user.cosyToken };
    return this.http.post(this.url + 'auth/authenticate', body, httpOptions);
  }

  switchApp(user: User) {
    let controllerMethod: string = 'auth/switchToBackendApp';
    if (user.login == 'MyApp') controllerMethod = 'auth/switchToApp';
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = { login: user.login, password: user.password, authToken: user.authToken, mandatorID: user.mandatorID, appID: user.appID, managedAppID: user.managedAppID, autoAuthorize: user.autoAuthorize, cosyToken: user.cosyToken };
    return this.http.post(this.url + controllerMethod, body, httpOptions);
  }

  getRuntimeKeys(sessionID: String) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = { SessionID: sessionID };
    return this.http.post(this.url + 'key/getRuntimeKeys', body, httpOptions).pipe(
      map(res => { 
        return res 
      }))
  }

  getRuntimeKey(sessionID: String, key: String) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = { SessionID: sessionID, keyName: key };
    return this.http.post(this.url + 'key/getRuntimeKey', body, httpOptions).pipe(
      map(res => { 
        return res 
      }))
  }

  getContextKey(sessionID: String, key: String) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = { SessionID: sessionID, keyName: key };
    return this.http.post(this.url + 'key/getContextKey', body, httpOptions).pipe(
      map(res => { 
        return res 
      }))
  }

  getGetTextShort(sessionID: String, did: String) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = { SessionID: sessionID, DID: did };
    return this.http.post(this.url + 'dict/getTextShortByDID', body, httpOptions).pipe(
      map(res => { return res }))
  }

  getSessionKey(sessionID: String, key: String) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = { sessionID: sessionID, keyName: key };
    return this.http.post(this.url + 'key/getSessionKey', body, httpOptions).pipe(
      map(res => { return res }))
  }

  setSessionKey(sessionID: String, key: String, valueString: String) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = { sessionID: sessionID, keyName: key , valueString: valueString};
    return this.http.post(this.url + 'key/setSessionKey', body, httpOptions).pipe(
      map(res => { return res }))
  }

  closeSessionKey(sessionID: String){
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = { sessionID: sessionID };
    return this.http.post(this.url + ' /dux/closeSession', body, httpOptions).pipe(
      map(res => { return res }))
  }

  getAppMapPath(cosyToken: String, searchText: String){
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = {cosyToken: cosyToken ,searchText: searchText};
    return this.http.post(this.url + 'services/getAppMapPath', body, httpOptions).pipe(
      map(res => { return res }))
  }

  getAppList(cosyToken: String) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let controllerMethod: string = 'services/getAppList';
    if (cosyToken == null) {
      cosyToken = '91242d63-6822-47f7-a9dc-628e0e89db80';
      controllerMethod = 'services/getAppListAdmin';
    }
    let body = {
      sessionID: cosyToken,
      mandatorID: '91242d63-6822-47f7-a9dc-628e0e89db80',
      variantID: '91242d63-6822-47f7-a9dc-628e0e89db80',
      dataRealmID: '91242d63-6822-47f7-a9dc-628e0e89db80'
    };
    return this.http.post(this.url + controllerMethod, body).pipe(
      map(res => { return res }))
  }

  getSearchData(flexSearch: FlexSearchRequest) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let controllerMethod: string = 'services/getSearchData';

    this.searchOption.forEach(element => flexSearch.searchText += element.searchString);
    let body = flexSearch;
    return this.http.post(this.url + controllerMethod, body, httpOptions).pipe(
      map(res => { return res }))
  }

  getAllCollection(cosyToken: String, searchText: string, sortOrder: string, rowsPerPage: number, page: number, entityID: string) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let controllerMethod: string = 'services/getAllCollection';

    let body = {
      sessionID: cosyToken,
      searchText: searchText,
      sortOrder: sortOrder,
      rowsPerPage: rowsPerPage,
      page: page,
      objectID: entityID
    };
    return this.http.post(this.url + controllerMethod, body, httpOptions).pipe(
      map(res => { return res }))
  }

  getObjectRegistryList(cosyToken: string, searchText: string, sortOrder: string, rowsPerPage: number, page: number, objectTypeDID: string, entityID: string) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let controllerMethod: string = 'services/getObjectRegistryList';
    if (objectTypeDID == '03f16433-ca30-4f82-a798-4914f6698170') controllerMethod = 'services/getAttributeList';
    if (cosyToken == null) {
      cosyToken = '91242d63-6822-47f7-a9dc-628e0e89db80';
    }
    let body = {
      sessionID: cosyToken,
      searchText: searchText,
      sortOrder: sortOrder,
      rowsPerPage: rowsPerPage,
      page: page,
      objectID: objectTypeDID,
      entityID: entityID
    };
    return this.http.post(this.url + controllerMethod, body, httpOptions).pipe(
      map(res => { return res }))
  }

  getObjectRegistryTypes(cosyToken: string) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let controllerMethod: string = 'services/getObjectRegistryTypes';
    if (cosyToken == null) {
      cosyToken = '91242d63-6822-47f7-a9dc-628e0e89db80';
    }
    let body = {
      sessionID: cosyToken,
    };
    return this.http.post(this.url + controllerMethod, body, httpOptions).pipe(
      map(res => { return res }))
  }

  showNdownloadPDF(value: any) {
    const header = new HttpHeaders({ Accept: 'application/pdf' });
    let url = this.config.getConfig('apiURL');
    let body = {
      sessionID: this.sessionID,
      documentID: value
    };
    const httpOptions = {
      headers: header
    };
    return this.http.post(url + 'documents/getDocument', body, httpOptions).pipe(
      map(res => { return res }))
  }

  addToCollection(cosyToken: string, collectionID: string, entityID: string, entityItemID: string[], displayName: string[]) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let controllerMethod: string = 'services/addToCollection';
    let body = {
      sessionID: cosyToken,
      collectionID: collectionID,
      entityID: entityID,
      entityItemID: entityItemID,
      displayName: displayName
    };
    return this.http.post(this.url + controllerMethod, body, httpOptions).pipe(
      map(res => { return res }))
  }

  removeFromCollection(cosyToken: string, collectionID: string, entityItemID: string[]) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let controllerMethod: string = 'services/removeFromCollection';
    let body = {
      sessionID: cosyToken,
      collectionID: collectionID,
      entityItemID: entityItemID,
    };
    return this.http.post(this.url + controllerMethod, body, httpOptions).pipe(
      map(res => { return res }))
  }

  setDragnDropInTree(cosyToken: string,groupID: any, treeItemID: any, fatherID: any, position: number){
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
   
    let body = {
      cosyToken : cosyToken,
      groupID : groupID,
      id : treeItemID,
      fatherId: fatherID,
      position: position

    };

    console.log('Body: ', body )
    return this.http.post(this.url + 'services/drop', body, httpOptions).pipe(
      map(res => { 
        return res
       }))
  }

 /* postChangedAsdToCosyAPI(url, data) {
    let body = data;
    let headers = new Headers({ 'Content-Type': 'application/json' });
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    this.http
      .post(url, body, httpOptions).pipe(
        map(this.extractData))
      .subscribe(
        asdData => console.log('New Asd values are posted to CosyJS API'),
        error => console.error('ERROR: ', error),
        () => console.log('Finished Updation of COSY Form.')
      );
  }*/

  /*private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }*/

  responsePerErrorToken(errorCode: number) {
    let responseMsg: { showErrorMsg: boolean; errorMsg: string } = { showErrorMsg: false, errorMsg: '' };
    if (errorCode == -1) {
      responseMsg.showErrorMsg = true;
      responseMsg.errorMsg = 'Dieser Login exitiert nicht';
    } else if (errorCode == -2) {
      responseMsg.showErrorMsg = true;
      responseMsg.errorMsg = 'Die Kombination Login/Passwort war leider nicht erfolgreich';
    } else if (errorCode == -3) {
      responseMsg.showErrorMsg = true;
      responseMsg.errorMsg = 'Ihr Login wurde deaktiviert';
    } else if (errorCode == -4) {
      responseMsg.showErrorMsg = true;
      responseMsg.errorMsg = 'Login expired';
    } else if (errorCode == -5) {
      responseMsg.showErrorMsg = true;
      responseMsg.errorMsg = 'Login not active';
    } else if (errorCode == -7) {
      responseMsg.showErrorMsg = true;
      responseMsg.errorMsg = 'Login Authtoken not exist';
    } else if (errorCode == -8) {
      responseMsg.showErrorMsg = true;
      responseMsg.errorMsg = 'Login Activation missing';
    } else if (errorCode == -10) {
      responseMsg.showErrorMsg = true;
      responseMsg.errorMsg = 'Dieser Login hat keine Rechte für dieses App';
    } else if (errorCode == -102) {
      responseMsg.showErrorMsg = true;
      responseMsg.errorMsg = 'Dieser Login exitiert nicht';
    }
    return responseMsg;
  }

  //Tree
  executeTree(userActionID: string, treeRequest: TreeRequest) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let controllerMethod: string = 'services/getTree';
    let body = treeRequest;
    switch (userActionID) {
      case  TreeUseractions.GetTree : {  //GetTree
        controllerMethod = 'services/getTree';
        break;
      }
      case TreeUseractions.ItemMoveLeft: {  //ItemMoveLeft
        controllerMethod = 'services/levelUp';
        break;
      }
      case TreeUseractions.ItemMoveRight : {  //ItemMoveRight
        controllerMethod = 'services/levelDown';
        break;
      }
      case TreeUseractions.ItemMoveUp : {  //ItemMoveUp
        controllerMethod = 'services/up';
        break;
      }
      case TreeUseractions.ItemMoveDown: {   //ItemMoveDown
        controllerMethod = 'services/down';
        break;
      }
      case TreeUseractions.ItemAdd : {   //ItemAdd
        controllerMethod = 'services/addItem';
        break;
      }
      case TreeUseractions.ItemRemove : {   //ItemRemove
        controllerMethod = 'services/removeSubtree';
        break;
      }
      case  TreeUseractions.TreeCreate: {   //TreeCreate
        controllerMethod = 'services/createTree';
        break;
      }
      case  TreeUseractions.TreeRemove : {   //TreeRemove
        controllerMethod = 'services/removeSubtree';
        break;
      }
    }

    return this.http.post(this.url + controllerMethod, body, httpOptions).pipe(
      map(res => { return res }))
  }

  getDisplayNameForCOSYEntityRecord(sessionID: String, entityID: String, attibuteName: String, entityRecordID: String) {
    const header = new HttpHeaders();
    header.append('Access-Control-Allow-Headers', 'Content-Type');
    header.append('Access-Control-Allow-Methods', 'POST');
    header.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      headers: header
    };
    let body = { cosyToken: sessionID, entityID: entityID, attibuteName: attibuteName, entityRecordID: entityRecordID };
    return this.http.post(this.url + 'dux/getDisplayNameForCOSYEntityRecord', body, httpOptions).pipe(
      map(res => { 
        return res 
      }))
  }
}

export class SearchOption {
  ID: string;
  treeID: string;
  displayName: string;
  searchString: string;
  attributes: AttributeSearch[];
  type: string;
  displayPath: string;
}

export class AttributeSearch {
  name: string;
  value: any;
}
